import  { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation, } from 'react-i18next';




interface HelmetProps {
    title: string

}



const BtHelmet: FunctionComponent<HelmetProps> = ({ title }) => {
    const { t } = useTranslation();

    return (<>
        <Helmet>
            <title>{t('meta.title')}{title}</title>
            <meta property='og:title' content={t('meta.description')}/>
        </Helmet>
    </>
    )

}

export default BtHelmet;